import * as React from 'react'

import { Form } from 'factorial-form'
import { TimesheetPageShiftFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import FancyCheckbox from 'modules/core/components/Inputs/LabeledFancyCheckbox'
import i18n from 'modules/core/lib/i18n'

import AttendanceShiftUtils from 'modules/attendance/lib/utils/AttendanceShift'

interface Props {
  shift: TimesheetPageShiftFragment
  disabled: boolean
}

const Checkbox = ({ shift, disabled }: Props) => {
  const label = AttendanceShiftUtils.isFirstHalf(shift)
    ? i18n.t('clock_in.first_half')
    : i18n.t('clock_in.second_half')

  const form = new Form(
    {
      value: !AttendanceShiftUtils.isNew(shift),
    },
    {
      value: 'boolean',
    }
  )

  return <FancyCheckbox label={label} field={form.get('value')} readOnly={disabled} size="200" />
}

export default observer(Checkbox)
